import { TENANT_CONFIG, TENANT_NAME } from 'constants/tenant-config';

// Import agency tier logos
import GeneralTIBLogo from 'assets/images/agency/logo/General_TIB.png';
import SilverTIBLogo from 'assets/images/agency/logo/Silver_TIB.png';
import GoldTIBLogo from 'assets/images/agency/logo/Gold_TIB.png';
import PlatinumTIBLogo from 'assets/images/agency/logo/Platinum_TIB.png';
import SapphireTIBLogo from 'assets/images/agency/logo/Sapphire_TIB.png';

import GeneralReachRightAdsLogo from 'assets/images/agency/logo/General_REACHRIGHTADS.png';
import SilverReachRightAdsLogo from 'assets/images/agency/logo/Silver_REACHRIGHTADS.png';
import GoldReachRightAdsLogo from 'assets/images/agency/logo/Gold_REACHRIGHTADS.png';
import PlatinumReachRightAdsLogo from 'assets/images/agency/logo/Platinum_REACHRIGHTADS.png';
import SapphireReachRightAdsLogo from 'assets/images/agency/logo/Sapphire_REACHRIGHTADS.png';

import GeneralConquestDSPLogo from 'assets/images/agency/logo/General_CONQUESTDSP.png';
import SilverConquestDSPLogo from 'assets/images/agency/logo/Silver_CONQUESTDSP.png';
import GoldConquestDSPLogo from 'assets/images/agency/logo/Gold_CONQUESTDSP.png';
import PlatinumConquestDSPLogo from 'assets/images/agency/logo/Platinum_CONQUESTDSP.png';
import SapphireConquestDSPLogo from 'assets/images/agency/logo/Sapphire_CONQUESTDSP.png';

class DomainManagementService {
  constructor() {
    this.currentDomain = this.detectDomain();
    this.domainConfig = this.getDomainConfig();
    this.initializeDomain();
  }

  // Core domain detection and configuration
  detectDomain() {
    const hostname = window.location.hostname;

    // Map hostname to brand
    const brandMap = {
      // Local domains
      localhost: TENANT_NAME.TIB,

      // Development domains
      'turnitblue-dev.saigontechnology.vn': TENANT_NAME.TIB,
      'tbd-dev.saigontechnology.vn': TENANT_NAME.TBD,
      'reachrightads-dev.saigontechnology.vn': TENANT_NAME.REACHRIGHTADS,
      'conquestdsp-dev.saigontechnology.vn': TENANT_NAME.CONQUESTDSP,

      // UAT domains
      'ads-uat.turnitbluedigital.com': TENANT_NAME.TIB,
      'ads-uat.tbd.com': TENANT_NAME.TBD,
      'ads-uat.reachrightads.com': TENANT_NAME.REACHRIGHTADS,
      'ads-uat.conquestdsp.com': TENANT_NAME.CONQUESTDSP,

      // staging domains
      'ads-staging.turnitbluedigital.com': TENANT_NAME.TIB,
      'ads-staging.tbd.com': TENANT_NAME.TBD,
      'ads-staging.reachrightads.com': TENANT_NAME.REACHRIGHTADS,
      'ads-staging.conquestdsp.com': TENANT_NAME.CONQUESTDSP,

      // Production domains
      'ads.turnitbluedigital.com': TENANT_NAME.TIB,
      'ads.tbd.com': TENANT_NAME.TBD,
      'app.reachrightads.com': TENANT_NAME.REACHRIGHTADS,
      'app.conquestdsp.com': TENANT_NAME.CONQUESTDSP,
    };

    return brandMap[hostname] || TENANT_NAME.TIB; // default fallback
  }

  getDomainConfig() {
    const currentDomain = this.currentDomain;

    const apiDomain = this.getApiDomainFromBrandKey(currentDomain);
    // The regex /\/api\/?$/ ensures that only the last occurrence of /api/ at the end of the string is removed.
    const backEndDomain = apiDomain.replace(/\/api\/?$/, '');

    const domainConfig = {
      domainKey: TENANT_CONFIG[currentDomain].key,
      name: TENANT_CONFIG[currentDomain].name,
      branding: TENANT_CONFIG[currentDomain].branding,
      hostname: this.getHostnameFromBrandKey(currentDomain),
      apiDomain: apiDomain,
      backendDomain: backEndDomain,
      affiliateProgramId: this.getAffiliateProgramIdFromBrandKey(currentDomain),
      languages: TENANT_CONFIG[currentDomain].languages,
    };

    return domainConfig;
  }

  getApiDomainFromBrandKey(brandKey) {
    const envKey = `REACT_APP_API_ROOT_${brandKey}`;
    return process.env[envKey] || process.env.REACT_APP_API_ROOT_TIB;
  }

  getAffiliateProgramIdFromBrandKey(brandKey) {
    const envKey = `REACT_APP_AFFILIATE_PROGRAM_ID_${brandKey}`;
    return (
      process.env[envKey] || process.env.REACT_APP_AFFILIATE_PROGRAM_ID_TIB
    );
  }

  getGtmIdFromBrandKey(brandKey) {
    const envKey = `REACT_APP_GTM_ID_${brandKey}`;
    return process.env[envKey] || process.env.REACT_APP_GTM_ID_TIB;
  }

  getHostnameFromBrandKey(brandKey) {
    const envKey = `REACT_APP_CUSTOMER_${brandKey}`;
    return process.env[envKey] || process.env.REACT_APP_CUSTOMER_TIB;
  }

  getTierAgencyPartnerList(brandKey) {
    const logoMap = {
      [TENANT_NAME.TIB]: {
        [`TIER_GENERAL_${brandKey}`]: {
          Name: 'General',
          Logo: GeneralTIBLogo,
        },
        [`TIER_SILVER_${brandKey}`]: {
          Name: 'Silver',
          Logo: SilverTIBLogo,
        },
        [`TIER_GOLD_${brandKey}`]: {
          Name: 'Gold',
          Logo: GoldTIBLogo,
        },
        [`TIER_PLATINUM_${brandKey}`]: {
          Name: 'Platinum',
          Logo: PlatinumTIBLogo,
        },
        [`TIER_SAPPHIRE_${brandKey}`]: {
          Name: 'Sapphire',
          Logo: SapphireTIBLogo,
        },
      },
      [TENANT_NAME.REACHRIGHTADS]: {
        [`TIER_GENERAL_${brandKey}`]: {
          Name: 'General',
          Logo: GeneralReachRightAdsLogo,
        },
        [`TIER_SILVER_${brandKey}`]: {
          Name: 'Silver',
          Logo: SilverReachRightAdsLogo,
        },
        [`TIER_GOLD_${brandKey}`]: {
          Name: 'Gold',
          Logo: GoldReachRightAdsLogo,
        },
        [`TIER_PLATINUM_${brandKey}`]: {
          Name: 'Platinum',
          Logo: PlatinumReachRightAdsLogo,
        },
        [`TIER_SAPPHIRE_${brandKey}`]: {
          Name: 'Sapphire',
          Logo: SapphireReachRightAdsLogo,
        },
      },
      [TENANT_NAME.CONQUESTDSP]: {
        [`TIER_GENERAL_${brandKey}`]: {
          Name: 'General',
          Logo: GeneralConquestDSPLogo,
        },
        [`TIER_SILVER_${brandKey}`]: {
          Name: 'Silver',
          Logo: SilverConquestDSPLogo,
        },
        [`TIER_GOLD_${brandKey}`]: {
          Name: 'Gold',
          Logo: GoldConquestDSPLogo,
        },
        [`TIER_PLATINUM_${brandKey}`]: {
          Name: 'Platinum',
          Logo: PlatinumConquestDSPLogo,
        },
        [`TIER_SAPPHIRE_${brandKey}`]: {
          Name: 'Titanium',
          Logo: SapphireConquestDSPLogo,
        },
      },
    };

    return logoMap[brandKey] || logoMap[TENANT_NAME.TIB];
  }

  getTierName(tier, brandKey) {
    const tierList = this.getTierAgencyPartnerList(brandKey);
    return tierList[`TIER_${tier?.toUpperCase()}_${brandKey}`]?.Name;
  }

  getApiDomain() {
    return this.domainConfig.apiDomain;
  }

  getBrandingConfig() {
    return this.domainConfig.branding;
  }

  getBrandColor() {
    return this.domainConfig.branding?.primaryColor || '#126a8a';
  }

  // Centralized error code mapping
  getErrorCode(errorKey) {
    return this.domainConfig.errorCodes[errorKey];
  }

  // Dynamic CSS variables injection
  injectBrandingStyles() {
    const branding = this.getBrandingConfig();
    const root = document.documentElement;

    const cssVarMap = {
      '--brand-color': branding.primaryBase,
      '--primary-lightest': branding.primaryLightest,
      '--primary-darkest': branding.primaryDarkest,
      '--primary-lighter': branding.primaryLighter,
      '--primary-medium': branding.primaryMedium,
      '--primary-strong': branding.primaryStrong,
    };

    Object.entries(cssVarMap).forEach(([key, value]) => {
      if (value) {
        root.style.setProperty(key, value);
      }
    });

  }

  // Update page metadata dynamically
  updatePageMetadata() {
    const branding = this.getBrandingConfig();

    // Update title
    document.title = this.domainConfig.name;

    // Update favicon - handle multiple favicon formats
    this.updateFavicon(branding.favicon);

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = this.domainConfig.name;
    }
  }

  // Update favicon with cache busting
  updateFavicon(faviconPath) {
    // Remove existing favicon links
    const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
    existingFavicons.forEach((link) => link.remove());

    // Use branding logo if available, otherwise fallback to faviconPath
    const branding = this.getBrandingConfig();
    let iconPath = faviconPath;

    // If branding has a logo, try to use it as favicon
    if (branding?.logo) {
      // If logo is a React component (SVG), we need to get its source
      if (typeof branding.logo === 'function' || branding.logo?.type) {
        // For React components, we'll use the faviconPath as fallback
        iconPath = faviconPath;
      } else if (typeof branding.logo === 'string') {
        // If logo is a string path, use it directly
        iconPath = branding.logo;
      }
    }

    // Create new favicon link with cache busting
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.type = iconPath.endsWith('.svg') ? 'image/svg+xml' : 'image/png';
    favicon.href = `${iconPath}?v=${Date.now()}`;
    document.head.appendChild(favicon);

    // Also update apple-touch-icon
    const appleTouchIcon = document.createElement('link');
    appleTouchIcon.rel = 'apple-touch-icon';
    appleTouchIcon.href = `${iconPath}?v=${Date.now()}`;
    document.head.appendChild(appleTouchIcon);
  }

  initializeDomain() {
    this.injectBrandingStyles();
    this.updatePageMetadata();
  }
}

const domainManagementService = new DomainManagementService();

export default domainManagementService;
